(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hotel-deal-sandbox"] && !Shopify.designMode) return;
  try {
    
(function(){
 function stellarFlowUrl(path){const current=new URLSearchParams(location.search);const preview=current.get('preview_theme_id');if(!preview)return path;const u=new URL(path,location.origin);u.searchParams.set('preview_theme_id',preview);return u.pathname+u.search+u.hash}
 function stellarDate(v){if(!v)return '';const p=String(v).split('-');return p.length===3?p[2]+'/'+p[1]+'/'+p[0]:v}
 const root=document.querySelector('[data-stellar-deal]');if(!root)return;
 const url='https://ginzdwfdmydobfougtho.supabase.co',key='sb_publishable_hKnyKyYCM9naNepQnHmPRA_wUraC2oY',storageKey='stellar_escapes_supabase_session';
 const box=document.getElementById('stellar-deal-content'),status=document.getElementById('stellar-deal-status'),q=new URLSearchParams(location.search);
 const source=q.get('source'),propertyId=q.get('property_id'),rateId=q.get('rate_id'),checkIn=q.get('check_in'),checkOut=q.get('check_out'),adults=Math.max(1,Number(q.get('adults')||2)),rooms=Math.max(1,Number(q.get('rooms')||1));
 function esc(v){return String(v==null?'':v).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]))}
 async function api(path,options,token){options=options||{};const h=new Headers(options.headers||{});h.set('apikey',key);if(!h.has('Content-Type'))h.set('Content-Type','application/json');if(token)h.set('Authorization','Bearer '+token);const res=await fetch(url+path,Object.assign({},options,{headers:h}));const t=await res.text();let d=null;try{d=t?JSON.parse(t):null}catch(e){d=t}if(!res.ok)throw new Error((d&&(d.message||d.msg||d.error_description||d.error))||'Request failed');return d}
 function readSession(){try{return JSON.parse(localStorage.getItem(storageKey)||'null')}catch(e){return null}}
 function saveSession(session){if(!session||!session.access_token)return;const expiresAt=session.expires_at||Math.floor(Date.now()/1000)+Number(session.expires_in||3600);localStorage.setItem(storageKey,JSON.stringify({access_token:session.access_token,refresh_token:session.refresh_token,expires_at:expiresAt}))}
 async function refreshSession(session){if(!session||!session.refresh_token)return null;const data=await api('/auth/v1/token?grant_type=refresh_token',{method:'POST',body:JSON.stringify({refresh_token:session.refresh_token})});saveSession(data);return readSession()}
 async function validSession(){let session=readSession();if(!session)return null;const now=Math.floor(Date.now()/1000);if(!session.expires_at||session.expires_at<=now+60){try{session=await refreshSession(session)}catch(e){localStorage.removeItem(storageKey);return null}}try{const user=await api('/auth/v1/user',{method:'GET'},session.access_token);return {session:session,user:user}}catch(e){try{session=await refreshSession(session);const user=await api('/auth/v1/user',{method:'GET'},session.access_token);return {session:session,user:user}}catch(e2){localStorage.removeItem(storageKey);return null}}}
 function money(n,c){return new Intl.NumberFormat('en-AU',{style:'currency',currency:c||'AUD',maximumFractionDigits:0}).format(Number(n||0))}
 function nights(){return Math.round((new Date(checkOut+'T00:00:00')-new Date(checkIn+'T00:00:00'))/86400000)}
 function loginRedirect(){const next=encodeURIComponent(location.pathname+location.search);location.assign(stellarFlowUrl('/pages/travel-login?next='+next))}
 async function prefill(){
   const current=await validSession();if(!current)return;
   const s=current.session;
   try{
     const user=current.user;
     const rows=await api('/rest/v1/profiles?id=eq.'+encodeURIComponent(user.id)+'&select=first_name,last_name&limit=1',{method:'GET'},s.access_token);
     const p=Array.isArray(rows)?rows[0]:rows;
     const first=document.getElementById('stellar-holder-first'),last=document.getElementById('stellar-holder-last'),email=document.getElementById('stellar-holder-email');
     if(first&&!first.value)first.value=(p&&p.first_name)||'';
     if(last&&!last.value)last.value=(p&&p.last_name)||'';
     if(email&&!email.value)email.value=user.email||'';
     for(let i=1;i<=rooms;i++){
       const gf=document.getElementById('stellar-guest-first-'+i),gl=document.getElementById('stellar-guest-last-'+i),ge=document.getElementById('stellar-guest-email-'+i);
       if(i===1){if(gf&&!gf.value)gf.value=first?first.value:'';if(gl&&!gl.value)gl.value=last?last.value:'';if(ge&&!ge.value)ge.value=email?email.value:''}
     }
   }catch(e){}
 }
 function guestFields(){
   let html='';
   for(let i=1;i<=rooms;i++){
     html+='<fieldset class="stellar-deal__guest"><legend>Primary guest — room '+i+'</legend><div class="stellar-deal__form-grid"><label>First name<input id="stellar-guest-first-'+i+'" required autocomplete="given-name"></label><label>Last name<input id="stellar-guest-last-'+i+'" required autocomplete="family-name"></label><label class="stellar-deal__wide">Email<input id="stellar-guest-email-'+i+'" type="email" required autocomplete="email"></label></div></fieldset>';
   }
   return html;
 }
 async function loadNuitee(){
  const offerId=q.get('offer_id'),hotelId=q.get('hotel_id')||'',hotelName=q.get('hotel_name')||'Nuitee hotel',roomName=q.get('room_name')||'Selected room',board=q.get('board')||'Room only',image=q.get('image')||'',searchTotal=Number(q.get('total')||0),currency=q.get('currency')||'AUD';
  if(!offerId||!checkIn||!checkOut||nights()<1){box.innerHTML='<p>This Nuitee deal link is incomplete. Please return to hotel search.</p>';return}
  box.innerHTML='<p>Rechecking this Nuitee sandbox rate…</p>';status.textContent='Running Nuitee prebook…';
  try{
   const pre=await api('/functions/v1/nuitee-prebook',{method:'POST',body:JSON.stringify({offerId:offerId})});
   const payload=pre&&pre.data?pre.data:{},data=payload.data||payload;
   const prebookId=data.prebookId||data.prebook_id||payload.prebookId||'';
   if(!prebookId)throw new Error('Nuitee did not return a prebook reference.');
   const priceChanged=Boolean(data.priceChanged||data.price_changed||payload.priceChanged);
   const totalObj=(data.retailRate&&Array.isArray(data.retailRate.total)&&data.retailRate.total[0])||(payload.retailRate&&Array.isArray(payload.retailRate.total)&&payload.retailRate.total[0]);
   const verifiedTotal=totalObj&&totalObj.amount!=null?Number(totalObj.amount):searchTotal,verifiedCurrency=(totalObj&&totalObj.currency)||currency;
   const cancel=data.cancellationPolicies||payload.cancellationPolicies||{};
   const cancelText=cancel.refundableTag==='RFN'?'Refundable rate':'Cancellation conditions confirmed at prebook.';
   box.innerHTML='<div class="stellar-deal__card">'+(image?'<img class="stellar-deal__image" src="'+esc(image)+'" alt="">':'')+'<div class="stellar-deal__body"><div class="stellar-deal__eyebrow">STELLAR ESCAPES · NUITEE SANDBOX</div><h1>'+esc(hotelName)+'</h1><div><span class="stellar-deal__pill">Nuitee Sandbox</span><span class="stellar-deal__pill">Prebook verified</span></div><div class="stellar-deal__summary"><strong>'+esc(roomName)+' · '+esc(board)+'</strong><div class="stellar-deal__row"><span>Stay</span><strong>'+esc(stellarDate(checkIn))+' → '+esc(stellarDate(checkOut))+'</strong></div><div class="stellar-deal__row"><span>Guests / rooms</span><strong>'+adults+' adults · '+rooms+' room'+(rooms>1?'s':'')+'</strong></div><div class="stellar-deal__row"><span>Total</span><strong class="stellar-deal__total">'+money(verifiedTotal,verifiedCurrency)+'</strong></div><p>'+esc(cancelText)+'</p>'+(priceChanged?'<p><strong>Price changed during prebook; the total above is the current sandbox rate.</strong></p>':'')+'</div><button class="stellar-deal__button" id="stellar-continue-booking" type="button">Book this deal</button><p class="stellar-deal__notice">Traveller details are added on the next page. SANDBOX ONLY — no real payment is charged.</p></div></div>';
   status.textContent='Nuitee sandbox prebook completed successfully.';
   document.getElementById('stellar-continue-booking').addEventListener('click',async function(){
     sessionStorage.setItem('stellar_escapes_booking_draft',JSON.stringify({source:'nuitee',prebookId:prebookId,hotelId:hotelId,hotelName:hotelName,roomName:roomName,board:board,image:image,checkIn:checkIn,checkOut:checkOut,adults:adults,rooms:rooms,expectedTotal:verifiedTotal,currency:verifiedCurrency}));
     const current=await validSession();
     if(!current){location.assign(stellarFlowUrl('/pages/travel-login?next='+encodeURIComponent(stellarFlowUrl('/pages/traveller-details'))));return}
     location.assign(stellarFlowUrl('/pages/traveller-details'));
   });
  }catch(e){box.innerHTML='<p>'+esc(e.message||'Nuitee could not prebook this rate.')+'</p>';status.textContent='Please return to hotel search and choose another sandbox rate.'}
 }
 async function loadStellar(){
  if(!propertyId||!rateId||!checkIn||!checkOut||nights()<1){box.innerHTML='<p>This test deal link is incomplete. Please return to hotel search.</p>';return}
  try{
   const ps=await api('/rest/v1/properties?id=eq.'+encodeURIComponent(propertyId)+'&is_active=eq.true&select=id,name,star_rating,city,description,amenities,images&limit=1');
   const rs=await api('/rest/v1/hotel_test_rates?id=eq.'+encodeURIComponent(rateId)+'&property_id=eq.'+encodeURIComponent(propertyId)+'&is_active=eq.true&select=id,room_name,board_basis,nightly_rate,currency,refundable,cancellation_text,inclusions&limit=1');
   if(!ps.length||!rs.length)throw new Error('This test deal is no longer available.');
   const p=ps[0],r=rs[0],n=nights(),total=Number(r.nightly_rate)*n*rooms,img=Array.isArray(p.images)&&p.images[0]?p.images[0]:'';
   box.innerHTML='<div class="stellar-deal__card">'+(img?'<img class="stellar-deal__image" src="'+esc(img)+'" alt="">':'')+'<div class="stellar-deal__body"><div class="stellar-deal__eyebrow">STELLAR ESCAPES · FALLBACK TEST DEAL</div><h1>'+esc(p.name)+'</h1><div>'+esc(p.city||'Bali')+' · '+esc(p.star_rating||'')+' ★</div><div class="stellar-deal__summary"><strong>'+esc(r.room_name)+' · '+esc(r.board_basis)+'</strong><div class="stellar-deal__row"><span>Stay</span><strong>'+esc(stellarDate(checkIn))+' → '+esc(stellarDate(checkOut))+'</strong></div><div class="stellar-deal__row"><span>Total</span><strong class="stellar-deal__total">'+money(total,r.currency)+'</strong></div><p>'+esc(r.cancellation_text||'')+'</p></div><button class="stellar-deal__button" type="button" disabled>Stellar fallback test rate</button></div></div>';status.textContent='Showing Stellar fallback inventory.';
  }catch(e){box.innerHTML='<p>'+esc(e.message||'Could not load this deal.')+'</p>'}
 }
 if(source==='nuitee')loadNuitee();else loadStellar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotel-search-sandbox"] && !Shopify.designMode) return;
  try {
    
(function(){
 function stellarFlowUrl(path){const current=new URLSearchParams(location.search);const preview=current.get('preview_theme_id');if(!preview)return path;const u=new URL(path,location.origin);u.searchParams.set('preview_theme_id',preview);return u.pathname+u.search+u.hash}
 function stellarDate(v){if(!v)return '';const p=String(v).split('-');return p.length===3?p[2]+'/'+p[1]+'/'+p[0]:v}
 const root=document.querySelector('[data-stellar-hotel-search]'); if(!root)return;
 const url='https://ginzdwfdmydobfougtho.supabase.co';
 const key='sb_publishable_hKnyKyYCM9naNepQnHmPRA_wUraC2oY';
 const form=document.getElementById('stellar-hotel-form');
 const results=document.getElementById('stellar-hotel-results');
 const status=document.getElementById('stellar-search-status');
 const checkin=document.getElementById('stellar-checkin');
 const checkout=document.getElementById('stellar-checkout');
 const adultsEl=document.getElementById('stellar-adults');
 const roomsEl=document.getElementById('stellar-rooms');
 const query=new URLSearchParams(location.search);
 const hotelIdParam=query.get('hotel_id')||'';
 const hotelNameParam=query.get('hotel_name')||'';
 const hotelHandleParam=query.get('hotel')||'';
 const destinationParam=query.get('destination')||'';
 const countryParam=query.get('country')||'';
 const destinationEl=document.getElementById('stellar-destination');
 if(destinationParam){
   const wanted=destinationParam.toLowerCase();
   const option=Array.from(destinationEl.options).find(o=>{
     const parts=String(o.value||'').split('|');
     return parts[0].toLowerCase()===wanted && (!countryParam || parts[1]===countryParam);
   });
   if(option) destinationEl.value=option.value;
 }
 if(hotelNameParam){
   const destinationLabel=hotelNameParam;
   const option=document.createElement('option');
   option.value='PROPERTY|';
   option.textContent=destinationLabel;
   destinationEl.replaceChildren(option);
   destinationEl.disabled=true;
 }
 const pad=n=>String(n).padStart(2,'0');
 const iso=d=>d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate());
 let a=new Date();a.setDate(a.getDate()+30);let b=new Date(a);b.setDate(b.getDate()+5);
 checkin.value=query.get('check_in')||iso(a);checkout.value=query.get('check_out')||iso(b);checkin.min=iso(new Date());checkout.min=iso(new Date());
 if(query.get('adults'))adultsEl.value=query.get('adults');
 if(query.get('rooms'))roomsEl.value=query.get('rooms');
 function esc(v){return String(v==null?'':v).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]))}
 function money(amount,currency){return new Intl.NumberFormat('en-AU',{style:'currency',currency:currency||'AUD',maximumFractionDigits:0}).format(Number(amount||0))}
 function nights(){return Math.round((new Date(checkout.value+'T00:00:00')-new Date(checkin.value+'T00:00:00'))/86400000)}
 async function functionPost(name,payload){
   const res=await fetch(url+'/functions/v1/'+name,{method:'POST',headers:{'Content-Type':'application/json','apikey':key},body:JSON.stringify(payload)});
   const text=await res.text();let data=null;try{data=text?JSON.parse(text):null}catch(e){data={error:text}}
   if(!res.ok)throw new Error((data&&(data.error||data.message))||'Supplier search failed');return data;
 }
 function firstRate(entry){const roomTypes=Array.isArray(entry&&entry.roomTypes)?entry.roomTypes:[];for(const roomType of roomTypes){const rates=Array.isArray(roomType&&roomType.rates)?roomType.rates:[];if(rates.length)return {offerId:roomType.offerId||'',rate:rates[0]}}return null}
 function renderNuitee(data,n){
   const hotelMap={};(Array.isArray(data.hotels)?data.hotels:[]).forEach(h=>{hotelMap[String(h.id||h.hotelId||'')]=h});
   const items=Array.isArray(data.data)?data.data:[];let count=0;
   items.forEach(entry=>{
     const picked=firstRate(entry);if(!picked)return;const h=hotelMap[String(entry.hotelId)]||{};const r=picked.rate||{};
     const totalObj=r.retailRate&&Array.isArray(r.retailRate.total)?r.retailRate.total[0]:null;if(!totalObj||totalObj.amount==null)return;
     const total=Number(totalObj.amount),currency=totalObj.currency||'AUD',nightly=n>0?total/n:total;
     const image=h.main_photo||h.mainPhoto||h.thumbnail||'',name=h.name||hotelNameParam||('Hotel '+entry.hotelId),address=h.address||h.formattedAddress||(destinationParam||'Destination'),rating=h.rating||h.starRating||'';
     const board=r.boardName||'Room only',roomName=r.name||'Available room',cancellation=r.cancellationPolicies||{},refundable=(cancellation.refundableTag||'').toUpperCase()==='RFN';
     const buttonUrl='/pages/hotel-deal?source=nuitee&hotel_id='+encodeURIComponent(entry.hotelId)+'&offer_id='+encodeURIComponent(picked.offerId||'')+'&check_in='+encodeURIComponent(checkin.value)+'&check_out='+encodeURIComponent(checkout.value)+'&adults='+encodeURIComponent(adultsEl.value)+'&rooms='+encodeURIComponent(roomsEl.value)+'&hotel_name='+encodeURIComponent(name)+'&room_name='+encodeURIComponent(roomName)+'&board='+encodeURIComponent(board)+'&total='+encodeURIComponent(total)+'&currency='+encodeURIComponent(currency)+'&image='+encodeURIComponent(image);
     const card=document.createElement('article');card.className='stellar-hotel';
     card.innerHTML=(image?'<img class="stellar-hotel__image" src="'+esc(image)+'" alt="" loading="lazy">':'')+'<div class="stellar-hotel__body"><div class="stellar-hotel__top"><div><h2>'+esc(name)+'</h2><div>'+esc(address)+'</div></div><div class="stellar-hotel__stars">'+(rating?esc(rating)+' ★':'')+'</div></div><div><span class="stellar-hotel__pill">'+(refundable?'Refundable':'Cancellation rules apply')+'</span></div><div class="stellar-hotel__rate"><div><div>'+esc(roomName)+' · '+esc(board)+'</div><div class="stellar-hotel__small">'+esc(refundable?'Refundable rate':'See deal for cancellation conditions')+'</div></div><div><div class="stellar-hotel__price">'+money(total,currency)+'</div><div class="stellar-hotel__small">'+n+' nights · approx. '+money(nightly,currency)+'/night</div><a class="stellar-hotel__button" href="'+esc(buttonUrl)+'">View Deal</a></div></div></div>';
     results.appendChild(card);count++;
   });return count;
 }


 form.addEventListener('submit',async e=>{
   e.preventDefault();results.replaceChildren();const n=nights();if(n<1){status.textContent='Check-out must be after check-in.';return}
   if(Number(adultsEl.value)<Number(roomsEl.value)){status.textContent='Each room needs at least one adult.';return}
   if(hotelNameParam && !hotelIdParam){
     status.textContent='Rates for '+hotelNameParam+' are being connected to our supplier inventory. Please choose another hotel or contact 1300 559 351 for assistance.';
     return;
   }
   status.textContent=hotelIdParam?'Checking availability for '+(hotelNameParam||'this hotel')+'…':'Checking hotel availability…';
   try{
     const payload={checkin:checkin.value,checkout:checkout.value,currency:'AUD',guestNationality:'AU',adults:Number(adultsEl.value),rooms:Number(roomsEl.value)};
     if(hotelIdParam){
       payload.hotelIds=[hotelIdParam];
     }else{
       const parts=String(destinationEl.value||'').split('|');
       payload.cityName=parts[0]||'';
       payload.countryCode=parts[1]||'';
       payload.limit=20;
     }
     const data=await functionPost('nuitee-hotel-search',payload);
     if(data&&data.stellarSource==='NUITEE_SANDBOX'){
       status.textContent='Live supplier rates are not yet enabled for online booking. Please call 1300 559 351 for current availability.';
       return;
     }
     const found=renderNuitee(data,n);
     if(found){status.textContent=hotelIdParam?'Current availability found for '+(hotelNameParam||'this hotel')+'.':found+' hotels found.';return}
     status.textContent='No supplier rates are available for these dates.';
   }catch(err){
     status.textContent=(err&&err.message?err.message:'Hotel availability is temporarily unavailable.');
   }
 });
 form.requestSubmit();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stellar-hotels-collection"] && !Shopify.designMode) return;
  try {
    
(function(){const form=document.getElementById('StellarHotelFilters');if(!form)return;const toggle=form.querySelector('[data-filter-toggle]');if(toggle)toggle.addEventListener('click',()=>form.classList.toggle('is-open'));const sort=form.querySelector('#StellarSort');if(sort)sort.addEventListener('change',()=>form.submit());})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stellar-luxe-product"] && !Shopify.designMode) return;
  try {
    
(function(){
 function stellarFlowUrl(path){const current=new URLSearchParams(location.search);const preview=current.get('preview_theme_id');if(!preview)return path;const u=new URL(path,location.origin);u.searchParams.set('preview_theme_id',preview);return u.pathname+u.search+u.hash}
 function stellarDate(v){if(!v)return '';const p=String(v).split('-');return p.length===3?p[2]+'/'+p[1]+'/'+p[0]:v}
 const root=document.querySelector('[data-stellar-product]');
 const button=document.getElementById('stellar-product-search');if(!button||!root)return;
 const hotelId=root.dataset.hotelId||'';
 const hotelHandle=root.dataset.hotelHandle||'';
 const hotelName=root.dataset.hotelName||'';
 const modal=document.getElementById('stellar-luxe-gallery-modal');
 const slides=modal?Array.from(modal.querySelectorAll('[data-stellar-gallery-slide]')):[];
 const count=modal?modal.querySelector('[data-stellar-gallery-count]'):null;
 let galleryIndex=0;
 function showGallery(index){if(!modal||!slides.length)return;galleryIndex=(index+slides.length)%slides.length;slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===galleryIndex));if(count)count.textContent=(galleryIndex+1)+' / '+slides.length}
 document.querySelectorAll('[data-stellar-gallery-open]').forEach(trigger=>trigger.addEventListener('click',function(){showGallery(Number(this.dataset.stellarGalleryOpen)||0);modal.showModal()}));
 if(modal){modal.querySelector('[data-stellar-gallery-close]').addEventListener('click',()=>modal.close());modal.querySelector('[data-stellar-gallery-prev]').addEventListener('click',()=>showGallery(galleryIndex-1));modal.querySelector('[data-stellar-gallery-next]').addEventListener('click',()=>showGallery(galleryIndex+1));modal.addEventListener('click',e=>{if(e.target===modal)modal.close()});modal.addEventListener('keydown',e=>{if(e.key==='ArrowLeft')showGallery(galleryIndex-1);if(e.key==='ArrowRight')showGallery(galleryIndex+1)})}
 const checkin=document.getElementById('stellar-product-checkin');
 const checkout=document.getElementById('stellar-product-checkout');
 const adults=document.getElementById('stellar-product-adults');
 const rooms=document.getElementById('stellar-product-rooms');
 const pad=n=>String(n).padStart(2,'0');
 const iso=d=>d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate());
 let a=new Date();a.setDate(a.getDate()+30);let b=new Date(a);b.setDate(b.getDate()+5);
 checkin.value=iso(a);checkout.value=iso(b);checkin.min=iso(new Date());checkout.min=iso(new Date());
 button.addEventListener('click',function(){
   if(!checkin.value||!checkout.value||new Date(checkout.value)<=new Date(checkin.value)){checkout.focus();return}
   const params=new URLSearchParams({hotel:hotelHandle,hotel_name:hotelName,check_in:checkin.value,check_out:checkout.value,adults:adults.value,rooms:rooms.value});
   if(hotelId)params.set('hotel_id',hotelId);
   location.assign(stellarFlowUrl('/pages/hotel-search?'+params.toString()));
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travel-account"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-travel-auth]');
  if (!root) return;

  var supabaseUrl = 'https://ginzdwfdmydobfougtho.supabase.co';
  var publishableKey = 'sb_publishable_hKnyKyYCM9naNepQnHmPRA_wUraC2oY';
  var storageKey = 'stellar_escapes_supabase_session';
  var view = root.dataset.view;
  var statusEl = document.getElementById('travel-auth-status');

  function setStatus(message, isError) {
    if (!statusEl) return;
    statusEl.textContent = message || '';
    statusEl.setAttribute('data-error', isError ? 'true' : 'false');
  }

  async function api(path, options, accessToken) {
    options = options || {};
    var headers = new Headers(options.headers || {});
    headers.set('apikey', publishableKey);
    if (!headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
    if (accessToken) headers.set('Authorization', 'Bearer ' + accessToken);
    var response = await fetch(supabaseUrl + path, Object.assign({}, options, { headers: headers }));
    var text = await response.text();
    var data = null;
    if (text) {
      try { data = JSON.parse(text); } catch (error) { data = text; }
    }
    if (!response.ok) {
      var message = response.statusText;
      if (data && typeof data === 'object') {
        message = data.msg || data.message || data.error_description || data.error || response.statusText;
      }
      throw new Error(message || 'Request failed');
    }
    return data;
  }

  function saveSession(session) {
    if (!session || !session.access_token) return;
    var expiresAt = session.expires_at || Math.floor(Date.now() / 1000) + Number(session.expires_in || 3600);
    localStorage.setItem(storageKey, JSON.stringify({
      access_token: session.access_token,
      refresh_token: session.refresh_token,
      expires_at: expiresAt
    }));
  }

  function clearSession() {
    localStorage.removeItem(storageKey);
  }

  function readSession() {
    try { return JSON.parse(localStorage.getItem(storageKey) || 'null'); }
    catch (error) { return null; }
  }

  async function refreshSession(session) {
    if (!session || !session.refresh_token) return null;
    var data = await api('/auth/v1/token?grant_type=refresh_token', {
      method: 'POST',
      body: JSON.stringify({ refresh_token: session.refresh_token })
    });
    saveSession(data);
    return readSession();
  }

  async function validSession() {
    var session = readSession();
    if (!session) return null;
    var now = Math.floor(Date.now() / 1000);
    if (!session.expires_at || session.expires_at <= now + 60) {
      try { session = await refreshSession(session); }
      catch (error) { clearSession(); return null; }
    }
    try {
      var user = await api('/auth/v1/user', { method: 'GET' }, session.access_token);
      return { session: session, user: user };
    } catch (error) {
      clearSession();
      return null;
    }
  }

  function redirectToLogin() {
    var next = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.assign('/pages/travel-login?next=' + next);
  }

  function afterLoginPath() {
    var next = new URLSearchParams(window.location.search).get('next');
    if (next && next.indexOf('/pages/') === 0) return next;
    return '/pages/my-account';
  }

  async function ensureProfile(user, accessToken) {
    var found = await api('/rest/v1/profiles?id=eq.' + encodeURIComponent(user.id) + '&select=id&limit=1', {
      method: 'GET',
      headers: { Accept: 'application/json' }
    }, accessToken);
    if (Array.isArray(found) && found.length) return found[0];

    var metadata = user.user_metadata || {};
    var created = await api('/rest/v1/profiles', {
      method: 'POST',
      headers: { Prefer: 'return=representation' },
      body: JSON.stringify({
        id: user.id,
        first_name: metadata.first_name || null,
        last_name: metadata.last_name || null
      })
    }, accessToken);
    return Array.isArray(created) ? created[0] : created;
  }

  function bindSignout(session) {
    root.querySelectorAll('[data-travel-signout]').forEach(function (button) {
      button.addEventListener('click', async function () {
        try { await api('/auth/v1/logout', { method: 'POST' }, session.access_token); }
        catch (error) {}
        clearSession();
        window.location.assign('/pages/travel-login');
      });
    });
  }

  async function initLogin() {
    var existing = await validSession();
    if (existing) {
      window.location.replace(afterLoginPath());
      return;
    }

    var loginForm = document.getElementById('travel-login-form');
    var signupForm = document.getElementById('travel-signup-form');

    if (loginForm) {
      loginForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        setStatus(root.dataset.loading, false);
        var form = new FormData(loginForm);
        try {
          var data = await api('/auth/v1/token?grant_type=password', {
            method: 'POST',
            body: JSON.stringify({
              email: String(form.get('email') || '').trim(),
              password: String(form.get('password') || '')
            })
          });
          saveSession(data);
          var current = await validSession();
          if (!current) throw new Error(root.dataset.loginError);
          await ensureProfile(current.user, current.session.access_token);
          window.location.assign(afterLoginPath());
        } catch (error) {
          setStatus(error.message || root.dataset.loginError, true);
        }
      });
    }

    if (signupForm) {
      signupForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        setStatus(root.dataset.loading, false);
        var form = new FormData(signupForm);
        try {
          var data = await api('/auth/v1/signup', {
            method: 'POST',
            body: JSON.stringify({
              email: String(form.get('email') || '').trim(),
              password: String(form.get('password') || ''),
              data: {
                first_name: String(form.get('first_name') || '').trim(),
                last_name: String(form.get('last_name') || '').trim()
              }
            })
          });
          if (data && data.access_token) {
            saveSession(data);
            var current = await validSession();
            if (current) await ensureProfile(current.user, current.session.access_token);
            window.location.assign(afterLoginPath());
            return;
          }
          signupForm.reset();
          setStatus(root.dataset.signupCheck, false);
        } catch (error) {
          setStatus(error.message || root.dataset.signupError, true);
        }
      });
    }
  }

  async function initAccount() {
    setStatus(root.dataset.loading, false);
    var current = await validSession();
    if (!current) {
      redirectToLogin();
      return;
    }
    bindSignout(current.session);
    await ensureProfile(current.user, current.session.access_token);

    try {
      var rows = await api('/rest/v1/profiles?id=eq.' + encodeURIComponent(current.user.id) + '&select=first_name,last_name,phone,country_code&limit=1', {
        method: 'GET',
        headers: { Accept: 'application/json' }
      }, current.session.access_token);
      var profile = Array.isArray(rows) ? rows[0] : rows;
      document.getElementById('travel-account-first').value = profile && profile.first_name ? profile.first_name : '';
      document.getElementById('travel-account-last').value = profile && profile.last_name ? profile.last_name : '';
      document.getElementById('travel-account-email').value = current.user.email || '';
      document.getElementById('travel-account-phone').value = profile && profile.phone ? profile.phone : '';
      document.getElementById('travel-account-country').value = profile && profile.country_code ? profile.country_code : '';
      setStatus('', false);
    } catch (error) {
      setStatus(error.message || root.dataset.accountError, true);
    }

    var form = document.getElementById('travel-account-form');
    if (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        setStatus(root.dataset.loading, false);
        var data = new FormData(form);
        try {
          await api('/rest/v1/profiles?id=eq.' + encodeURIComponent(current.user.id), {
            method: 'PATCH',
            headers: { Prefer: 'return=minimal' },
            body: JSON.stringify({
              first_name: String(data.get('first_name') || '').trim() || null,
              last_name: String(data.get('last_name') || '').trim() || null,
              phone: String(data.get('phone') || '').trim() || null,
              country_code: String(data.get('country_code') || '').trim().toUpperCase() || null,
              updated_at: new Date().toISOString()
            })
          }, current.session.access_token);
          setStatus(root.dataset.saved, false);
        } catch (error) {
          setStatus(error.message || root.dataset.accountError, true);
        }
      });
    }
  }

  async function initBookings() {
    setStatus(root.dataset.loading, false);
    var current = await validSession();
    if (!current) {
      redirectToLogin();
      return;
    }
    bindSignout(current.session);
    await ensureProfile(current.user, current.session.access_token);
    var list = document.getElementById('travel-bookings-list');

    try {
      var bookings = await api('/rest/v1/bookings?select=id,booking_reference,supplier_booking_id,status,check_in,check_out,adults,rooms,retail_amount,retail_currency,traveller_details,created_at&order=created_at.desc', {
        method: 'GET',
        headers: { Accept: 'application/json' }
      }, current.session.access_token);

      list.replaceChildren();
      if (!Array.isArray(bookings) || !bookings.length) {
        var empty = document.createElement('p');
        empty.textContent = root.dataset.noBookings;
        list.appendChild(empty);
        setStatus('', false);
        return;
      }

      function formatDate(value) {
        if (!value) return '—';
        return new Intl.DateTimeFormat('en-AU', { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(value + 'T00:00:00'));
      }

      function formatMoney(amount, currency) {
        if (amount == null) return '—';
        return new Intl.NumberFormat('en-AU', { style: 'currency', currency: currency || 'AUD' }).format(Number(amount));
      }

      async function manageBooking(booking, action, button, stateEl) {
        var refreshed = await validSession();
        if (!refreshed) {
          redirectToLogin();
          return;
        }
        var originalText = button.textContent;
        button.disabled = true;
        button.textContent = action === 'cancel' ? 'Cancelling…' : 'Checking…';
        setStatus(action === 'cancel' ? 'Cancelling Nuitee sandbox booking…' : 'Checking Nuitee booking status…', false);
        try {
          var result = await api('/functions/v1/nuitee-booking-manage', {
            method: 'POST',
            body: JSON.stringify({ bookingId: booking.id, action: action })
          }, refreshed.session.access_token);

          if (result && result.status) {
            booking.status = result.status;
            stateEl.textContent = result.status;
          }

          if (action === 'cancel') {
            setStatus('Nuitee sandbox booking cancelled successfully.', false);
            window.setTimeout(function () { window.location.reload(); }, 700);
          } else {
            setStatus('Supplier status: ' + (result.supplierStatus || result.status || 'checked'), false);
            button.disabled = false;
            button.textContent = originalText;
          }
        } catch (error) {
          setStatus(error.message || 'Booking management request failed.', true);
          button.disabled = false;
          button.textContent = originalText;
        }
      }

      bookings.forEach(function (booking) {
        var card = document.createElement('article');
        card.className = 'travel-auth__booking';

        var title = document.createElement('div');
        title.className = 'travel-auth__booking-title';
        var reference = document.createElement('strong');
        reference.textContent = booking.booking_reference || 'Booking';
        var state = document.createElement('span');
        state.textContent = booking.status || '';
        title.append(reference, state);
        card.appendChild(title);

        var travel = booking.traveller_details || {};
        if (travel.hotel_name) {
          var hotel = document.createElement('div');
          hotel.style.marginTop = '8px';
          var hotelName = document.createElement('strong');
          hotelName.textContent = travel.hotel_name;
          hotel.appendChild(hotelName);
          if (travel.room_name) {
            var room = document.createElement('div');
            room.textContent = travel.room_name;
            hotel.appendChild(room);
          }
          if (booking.supplier_booking_id) {
            var supplierRef = document.createElement('div');
            supplierRef.textContent = 'Supplier booking: ' + booking.supplier_booking_id;
            hotel.appendChild(supplierRef);
          }
          if (travel.hotel_confirmation_code) {
            var hotelRef = document.createElement('div');
            hotelRef.textContent = 'Hotel confirmation: ' + travel.hotel_confirmation_code;
            hotel.appendChild(hotelRef);
          }
          card.appendChild(hotel);
        }

        var grid = document.createElement('div');
        grid.className = 'travel-auth__booking-grid';
        var items = [
          ['Dates', formatDate(booking.check_in) + ' – ' + formatDate(booking.check_out)],
          ['Guests', booking.adults == null ? '—' : booking.adults],
          ['Rooms', booking.rooms == null ? '—' : booking.rooms],
          ['Total', formatMoney(booking.retail_amount, booking.retail_currency)]
        ];

        items.forEach(function (pair) {
          var item = document.createElement('div');
          var key = document.createElement('span');
          key.textContent = pair[0];
          var val = document.createElement('strong');
          val.textContent = String(pair[1]);
          item.append(key, val);
          grid.appendChild(item);
        });

        card.appendChild(grid);

        var isNuitee = booking.booking_reference && booking.booking_reference.indexOf('SE-NUI-') === 0 && booking.supplier_booking_id;
        if (isNuitee) {
          var actions = document.createElement('div');
          actions.className = 'travel-auth__booking-actions';

          var checkButton = document.createElement('button');
          checkButton.type = 'button';
          checkButton.className = 'travel-auth__booking-action';
          checkButton.textContent = 'Check Status';
          checkButton.addEventListener('click', function () {
            manageBooking(booking, 'status', checkButton, state);
          });
          actions.appendChild(checkButton);

          if (String(booking.status || '').toLowerCase() !== 'cancelled') {
            var cancelButton = document.createElement('button');
            cancelButton.type = 'button';
            cancelButton.className = 'travel-auth__booking-action travel-auth__booking-action--danger';
            cancelButton.textContent = 'Cancel Sandbox Booking';
            cancelButton.addEventListener('click', function () {
              var confirmed = window.confirm('Cancel this Nuitee sandbox booking? This will send a cancellation request to the Nuitee sandbox.');
              if (!confirmed) return;
              manageBooking(booking, 'cancel', cancelButton, state);
            });
            actions.appendChild(cancelButton);
          }

          card.appendChild(actions);
        }

        list.appendChild(card);
      });
      setStatus('', false);
    } catch (error) {
      setStatus(error.message || root.dataset.bookingsError, true);
    }
  }

  if (view === 'travel-login') initLogin();
  if (view === 'my-account') initAccount();
  if (view === 'my-bookings') initBookings();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["traveller-details"] && !Shopify.designMode) return;
  try {
    
(function(){
 function stellarFlowUrl(path){const current=new URLSearchParams(location.search);const preview=current.get('preview_theme_id');if(!preview)return path;const u=new URL(path,location.origin);u.searchParams.set('preview_theme_id',preview);return u.pathname+u.search+u.hash}
 function stellarDate(v){if(!v)return '';const p=String(v).split('-');return p.length===3?p[2]+'/'+p[1]+'/'+p[0]:v}
 const root=document.querySelector('[data-stellar-traveller]');if(!root)return;
 const url='https://ginzdwfdmydobfougtho.supabase.co',key='sb_publishable_hKnyKyYCM9naNepQnHmPRA_wUraC2oY',storageKey='stellar_escapes_supabase_session',draftKey='stellar_escapes_booking_draft';
 const box=document.getElementById('stellar-traveller-content'),status=document.getElementById('stellar-traveller-status');
 function esc(v){return String(v==null?'':v).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]))}
 function money(n,c){return new Intl.NumberFormat('en-AU',{style:'currency',currency:c||'AUD',maximumFractionDigits:2}).format(Number(n||0))}
 async function api(path,options,token){options=options||{};const h=new Headers(options.headers||{});h.set('apikey',key);if(!h.has('Content-Type'))h.set('Content-Type','application/json');if(token)h.set('Authorization','Bearer '+token);const res=await fetch(url+path,Object.assign({},options,{headers:h}));const t=await res.text();let d=null;try{d=t?JSON.parse(t):null}catch(e){d=t}if(!res.ok)throw new Error((d&&(d.message||d.msg||d.error_description||d.error))||'Request failed');return d}
 function readSession(){try{return JSON.parse(localStorage.getItem(storageKey)||'null')}catch(e){return null}}
 function saveSession(s){if(!s||!s.access_token)return;const expiresAt=s.expires_at||Math.floor(Date.now()/1000)+Number(s.expires_in||3600);localStorage.setItem(storageKey,JSON.stringify({access_token:s.access_token,refresh_token:s.refresh_token,expires_at:expiresAt}))}
 async function refreshSession(s){if(!s||!s.refresh_token)return null;const d=await api('/auth/v1/token?grant_type=refresh_token',{method:'POST',body:JSON.stringify({refresh_token:s.refresh_token})});saveSession(d);return readSession()}
 async function validSession(){let s=readSession();if(!s)return null;const now=Math.floor(Date.now()/1000);if(!s.expires_at||s.expires_at<=now+60){try{s=await refreshSession(s)}catch(e){localStorage.removeItem(storageKey);return null}}try{const user=await api('/auth/v1/user',{method:'GET'},s.access_token);return{session:s,user:user}}catch(e){try{s=await refreshSession(s);const user=await api('/auth/v1/user',{method:'GET'},s.access_token);return{session:s,user:user}}catch(e2){localStorage.removeItem(storageKey);return null}}}
 function loadDraft(){try{return JSON.parse(sessionStorage.getItem(draftKey)||'null')}catch(e){return null}}
 function guestFields(rooms){let html='';for(let i=1;i<=rooms;i++){html+='<fieldset class="stellar-traveller__guest"><legend>Primary guest — room '+i+'</legend><div class="stellar-traveller__form-grid"><label>First name<input id="stellar-guest-first-'+i+'" required autocomplete="given-name"></label><label>Last name<input id="stellar-guest-last-'+i+'" required autocomplete="family-name"></label><label class="stellar-traveller__wide">Email<input id="stellar-guest-email-'+i+'" type="email" required autocomplete="email"></label></div></fieldset>'}return html}
 function additionalGuestFields(adults,rooms){const count=Math.max(0,adults-rooms);if(!count)return '';let html='<details class="stellar-traveller__additional"><summary>Additional guests <span>'+count+' guest'+(count===1?'':'s')+'</span></summary><div class="stellar-traveller__additional-body">';for(let i=1;i<=count;i++){html+='<div class="stellar-traveller__additional-guest"><h3>Additional guest '+i+'</h3><div class="stellar-traveller__form-grid"><label>First name<input id="stellar-additional-first-'+i+'" required autocomplete="given-name"></label><label>Last name<input id="stellar-additional-last-'+i+'" required autocomplete="family-name"></label></div></div>'}return html+'</div></details>'}
 async function init(){
   const draft=loadDraft();if(!draft||draft.source!=='nuitee'||!draft.prebookId){box.innerHTML='<div class="stellar-traveller__card"><h1>No booking selected</h1><p>Please return to hotel search and choose a deal first.</p></div>';return}
   const current=await validSession();if(!current){location.assign(stellarFlowUrl('/pages/travel-login?next='+encodeURIComponent(stellarFlowUrl('/pages/traveller-details'))));return}
   box.innerHTML='<div class="stellar-traveller__card"><h1>Traveller details</h1><div class="stellar-traveller__summary"><strong>'+esc(draft.hotelName)+'</strong><div>'+esc(draft.roomName)+' · '+esc(draft.board||'')+'</div><div class="stellar-traveller__row"><span>Stay</span><strong>'+esc(stellarDate(draft.checkIn))+' → '+esc(stellarDate(draft.checkOut))+'</strong></div><div class="stellar-traveller__row"><span>Guests / rooms</span><strong>'+Number(draft.adults||1)+' adults · '+Number(draft.rooms||1)+' room'+(Number(draft.rooms||1)>1?'s':'')+'</strong></div><div class="stellar-traveller__row"><span>Total</span><strong class="stellar-traveller__total">'+money(draft.expectedTotal,draft.currency)+'</strong></div></div><form id="stellar-traveller-form"><div class="stellar-traveller__form-grid"><label>Booking holder first name<input id="stellar-holder-first" required autocomplete="given-name"></label><label>Booking holder last name<input id="stellar-holder-last" required autocomplete="family-name"></label><label class="stellar-traveller__wide">Booking holder email<input id="stellar-holder-email" type="email" required autocomplete="email"></label></div>'+guestFields(Number(draft.rooms||1))+additionalGuestFields(Number(draft.adults||1),Number(draft.rooms||1))+'<div class="stellar-traveller__form-grid"><label class="stellar-traveller__wide">Requests / notes<textarea id="stellar-special-requests" maxlength="500" placeholder="Optional — e.g. bedding preference, dietary needs, accessibility requests, celebration details or other notes"></textarea><span class="stellar-traveller__help">We will pass your request to the hotel where supported. Special requests are subject to availability and cannot be guaranteed.</span></label></div><button class="stellar-traveller__button" id="stellar-confirm-booking" type="submit">Confirm sandbox booking</button><p class="stellar-traveller__notice">SANDBOX ONLY — no real payment is charged.</p></form></div>';
   try{
     const rows=await api('/rest/v1/profiles?id=eq.'+encodeURIComponent(current.user.id)+'&select=first_name,last_name&limit=1',{method:'GET'},current.session.access_token);
     const p=Array.isArray(rows)?rows[0]:rows,first=document.getElementById('stellar-holder-first'),last=document.getElementById('stellar-holder-last'),email=document.getElementById('stellar-holder-email');
     first.value=(p&&p.first_name)||'';last.value=(p&&p.last_name)||'';email.value=current.user.email||'';
     const gf=document.getElementById('stellar-guest-first-1'),gl=document.getElementById('stellar-guest-last-1'),ge=document.getElementById('stellar-guest-email-1');if(gf)gf.value=first.value;if(gl)gl.value=last.value;if(ge)ge.value=email.value;
   }catch(e){}
   document.getElementById('stellar-traveller-form').addEventListener('submit',async function(e){
     e.preventDefault();const fresh=await validSession();if(!fresh){location.assign(stellarFlowUrl('/pages/travel-login?next='+encodeURIComponent(stellarFlowUrl('/pages/traveller-details'))));return}
     const btn=document.getElementById('stellar-confirm-booking');btn.disabled=true;btn.textContent='Confirming sandbox booking…';status.textContent='Sending booking to Nuitee sandbox…';
     try{
       const holder={firstName:document.getElementById('stellar-holder-first').value.trim(),lastName:document.getElementById('stellar-holder-last').value.trim(),email:document.getElementById('stellar-holder-email').value.trim()};
       const guests=[];for(let i=1;i<=Number(draft.rooms||1);i++){guests.push({firstName:document.getElementById('stellar-guest-first-'+i).value.trim(),lastName:document.getElementById('stellar-guest-last-'+i).value.trim(),email:document.getElementById('stellar-guest-email-'+i).value.trim()})}
       const additionalGuests=[];const extraCount=Math.max(0,Number(draft.adults||1)-Number(draft.rooms||1));for(let i=1;i<=extraCount;i++){additionalGuests.push({firstName:document.getElementById('stellar-additional-first-'+i).value.trim(),lastName:document.getElementById('stellar-additional-last-'+i).value.trim()})}
       const requestsEl=document.getElementById('stellar-special-requests');const specialRequests=requestsEl?requestsEl.value.trim():'';
       const booked=await api('/functions/v1/nuitee-book',{method:'POST',body:JSON.stringify({prebookId:draft.prebookId,holder:holder,guests:guests,additionalGuests:additionalGuests,specialRequests:specialRequests,checkIn:draft.checkIn,checkOut:draft.checkOut,adults:Number(draft.adults||1),rooms:Number(draft.rooms||1),expectedTotal:Number(draft.expectedTotal||0),currency:draft.currency||'AUD',hotelId:draft.hotelId||'',hotelName:draft.hotelName||'',roomName:draft.roomName||''})},fresh.session.access_token);
       if(!booked||!booked.ok)throw new Error('Nuitee did not confirm the sandbox booking.');
       sessionStorage.removeItem(draftKey);location.assign(stellarFlowUrl('/pages/my-bookings?created=nuitee'));
     }catch(err){status.textContent=err.message||'Could not confirm the Nuitee sandbox booking.';btn.disabled=false;btn.textContent='Confirm sandbox booking'}
   });
 }
 init();
})();

  } catch(e) { console.error(e); }
})();
})();
